import { render, staticRenderFns } from "./PersonalDetails.vue?vue&type=template&id=11a84dec&scoped=true&"
import script from "./PersonalDetails.vue?vue&type=script&lang=js&"
export * from "./PersonalDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a84dec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11a84dec')) {
      api.createRecord('11a84dec', component.options)
    } else {
      api.reload('11a84dec', component.options)
    }
    module.hot.accept("./PersonalDetails.vue?vue&type=template&id=11a84dec&scoped=true&", function () {
      api.rerender('11a84dec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-details/PersonalDetails.vue"
export default component.exports